<div id="{{ metricId | eroi:'summaryPillTitle' | lowercase }}-tvd-metric-summary" class="flex gap-6 justify-start items-center p-2">
   <div class="inner-container flex w-full rounded-[20px] px-6 py-4 bg-white/15">
    <div class="tvd-metric-summary-icon w-16 aspect-square bg-blue-700 rounded-md grid place-items-center">
      <div class="w-[70%] aspect-square bg-white rounded-full grid place-items-center overflow-hidden">
        <img src="{{ metricId | eroi:'summaryPillIcon' }}" alt="Metric Icon" class="w-[55%] h-auto object-contain" />
      </div>
    </div>

    <div class="tvd-metric-summary-details flex flex-col text-white">
      <div class="tvd-metric-summary-title text-2xl">{{ metricId | eroi:'summaryPillTitle' | capitalize}}</div>
      <div class="tvd-metric-summary-value flex gap-2">
        <ng-container *ngIf="isTvdLoadComplete; else loader">
          <span class="tvd-metric-summary-contribution text-[28px] font-bold">{{ valueContribution | number}}</span>
        </ng-container>
        <ng-template #loader>
          <loader size="small"></loader>
        </ng-template>
        <span class="tvd-metric-summary-unit text-base">{{ metricId | eroi:'units':{measurementSystem: measurementSystem} }}</span>
      </div>
    </div>
   </div>
  
</div>
